import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';
import { consts as checkInsuranceEligibilityConsts } from './check-insurance-eligibility';
import { consts as insuranceEligibilityManualActivationConsts } from '../../profiles/insurance-eligibility-manual-activations';

export const consts = createReqConsts(
  'appointment-form',
  'latest-check-insurance-eligibility',
);

export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'insurance_eligibility',
  type: 'get',
  slug: [
    'results',
    {
      type: 'payload.query',
      queryParameter: 'user_id',
      selector: 'userId',
    },
  ],
});

const requestReducer = createReqReducer(consts);

export default (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case checkInsuranceEligibilityConsts.SUCCEED:
    case insuranceEligibilityManualActivationConsts.SUCCEED: {
      return {
        ...state,
        ...payload,
        error: null,
      };
    }

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/requests/latest-check-insurance-req.js